import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BookOpenIcon, CalendarDaysIcon, ClipboardCheckIcon, GraduationCapIcon, ShoppingBagIcon, UtensilsIcon } from 'lucide-react';
import { demoDay } from '../../data/landingBVisual';

/**
 * A day, connected.
 *
 * Each moment links to the capability that actually carries it, so the
 * timeline is navigation rather than illustration. The day itself is
 * demonstration content and is labelled as such — it is not anyone's schedule.
 */
const ICONS = {
  class: GraduationCapIcon,
  library: BookOpenIcon,
  lunch: UtensilsIcon,
  assignment: ClipboardCheckIcon,
  event: CalendarDaysIcon,
  marketplace: ShoppingBagIcon
} as const;
export function DayTimeline() {
  return <section className="border-y border-line bg-surface py-7" data-id="element-2346" data-mp="nyirl5aouhl5">
      <div className="mx-auto max-w-[88rem] px-4 sm:px-8" data-id="element-2347" data-mp="1ufntdyh6a8un">
        <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-2348" data-mp="1zfs93ma9azjt">
          <p className="text-caption font-semibold uppercase tracking-[0.16em] text-ink-subtle" data-id="element-2349" data-mp="1zhv8gwxau517">
            A day connected by Campuzon
            <span className="ml-2 font-normal normal-case tracking-normal text-ink-subtle" data-id="element-2350" data-mp="3024vlxs37d81">
              (demonstration)
            </span>
          </p>
          <Link to="/academics" className="group inline-flex min-h-touch items-center gap-2 text-body-sm font-semibold text-brand-800" data-id="element-2351" data-mp="2v1qnkfqhk3a0">
            See your full day
            <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-2352" data-mp="2m4zrw4fuiqfy" />
          </Link>
        </div>

        <ol className="cz-tabstrip mt-5 flex items-start gap-0 pb-2" data-id="element-2353" data-mp="2cazfrim5ckxq">
          {demoDay.map((moment, index) => {
          const Icon = ICONS[moment.icon];
          return <li key={moment.time} className="relative flex min-w-[9.5rem] shrink-0 flex-1 items-start" data-id="element-2354" data-mp="22ee6gl33gno3" data-mpi={index}>
                {index < demoDay.length - 1 && <span aria-hidden className="absolute left-[1.375rem] top-[1.375rem] h-px w-full bg-line" data-id="element-2355" data-mp="1nrpbmwjseyo1" />}
                <Link to={moment.to} className="relative flex items-start gap-3 pr-6" data-id="element-2356" data-mp="1ersgcc2w71k0">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-line bg-canvas text-brand-800 transition-colors duration-150 ease-out hover:border-brand-200" data-id="element-2357" data-mp="1jqlxcehe1aox">
                    <Icon aria-hidden className="h-5 w-5" data-id="element-2358" data-mp="2bhjo3d072l7r" />
                  </span>
                  <span className="min-w-0 pt-1" data-id="element-2359" data-mp="2bjmaln251w7q">
                    <span className="cz-num block text-caption font-semibold text-ink-subtle" data-id="element-2360" data-mp="1xpbqjj136q80">
                      {moment.time}
                    </span>
                    <span className="block truncate text-body-sm font-semibold uppercase tracking-wide text-ink" data-id="element-2361" data-mp="2qf2baax84qd3">
                      {moment.label}
                    </span>
                  </span>
                </Link>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}